var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collapse-text',{attrs:{"text":"Cookies used by Timbre"}},[_c('ul',{staticClass:"cookies-list clean-list mt-2"},_vm._l((_vm.cookie_list),function(cookie_info){return _c('li',{key:cookie_info.name},[_c('strong',[_vm._v(_vm._s(cookie_info.name)+":")]),_vm._v(" "+_vm._s(cookie_info.desc)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }